import React from 'react'
import {
  Chart,
  Geom,
  Axis,
  Tooltip,
  Coord,
  Label,
  Legend,
  Guide,
} from 'bizcharts'
import DataSet from '@antv/data-set'

interface IPieChartProps {
  fieldKey: string
  item: string
  data: any[]
}

class PieChart extends React.Component<IPieChartProps> {
  render() {
    const { DataView } = DataSet
    const { Html } = Guide
    const { fieldKey, item, data } = this.props
    const dv = new DataView()
    dv.source(data).transform({
      type: 'percent',
      field: fieldKey,
      dimension: item,
      as: 'percent',
    })
    const cols = {
      percent: {
        formatter: val => {
          val = Math.round(val * 100 * 100) / 100 + '%'
          return val
        },
      },
    }
    return (
      <div>
        <Chart
          padding={[20, 100, 40, 60]}
          height={450}
          data={dv}
          scale={cols}
          forceFit
        >
          <Coord type={'theta'} radius={0.75} innerRadius={0.6} />
          <Axis name="percent" />
          <Legend position="right" offsetY={-450 / 2 + 120} offsetX={-100} />
          <Tooltip
            showTitle={false}
            itemTpl="<li><span style=&quot;background-color:{color};&quot; class=&quot;g2-tooltip-marker&quot;></span>{name}: {value}</li>"
          />
          <Geom
            type="intervalStack"
            position="percent"
            color={item}
            tooltip={[
              `${item}*percent`,
              (it, percent) => {
                percent = Math.round(percent * 100 * 100) / 100 + '%'
                return {
                  name: it,
                  value: percent,
                }
              },
            ]}
            style={{
              lineWidth: 1,
              stroke: '#fff',
            }}
          >
            <Label
              content="percent"
              formatter={(val, it) => {
                return it.point[item] + ': ' + val
              }}
            />
          </Geom>
        </Chart>
      </div>
    )
  }
}

export default PieChart
